import React from 'react'
import "./App.css";
import SideBar from "./components/Sidebar/SideBar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import AddContact from "./pages/AddContact";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ContactView from './pages/ContactView';
import EditContact from './pages/EditContact';
import AddSlider from "./pages/Slider/AddSlider";
import SliderView from "./pages/Slider/SliderView";
import EditSlider from "./pages/Slider/EditSlider";

import AddTestimonial from "./pages/Testimonial/AddTestimonial";
import EditTestimonial from "./pages/Testimonial/EditTestimonial";
import TestimonialView from "./pages/Testimonial/TestimonialView";

import AddProduct from "./pages/Product/AddProduct";
import EditProduct from "./pages/Product/EditProduct";
import ProductView from "./pages/Product/ProductView";

import AboutView from "./pages/About/AboutView";
import EditAbout from "./pages/About/EditAbout";
import FooterView from "./pages/Footer/FooterView";
import EditFooter from "./pages/Footer/EditFooter";
import ServiceView from "./pages/Service/ServiceView";
import EditService from "./pages/Service/EditService";

import HomePageServiceView from "./pages/HomePageService/HomePageServiceView";
import EditHomePageService from "./pages/HomePageService/EditHomePageService";

import AddCommunityFeature from "./pages/CommunityWebFeature/AddCommunityFeature";
import EditCommunityFeature from "./pages/CommunityWebFeature/EditCommunityFeature";
import CommunityFeatureView from "./pages/CommunityWebFeature/CommunityFeatureView";
import EditInvestment from "./pages/Investment/EditInvestment";
import InvestmentView from "./pages/Investment/InvestmentView";

import AddInvestmentDisburse from "./pages/Investment/AddInvestmentDisburse";
import EditInvestmentDisburse from "./pages/Investment/EditInvestmentDisburse";
import InvestmentDisburseView from "./pages/Investment/InvestmentDisburseView";

import Login from "./pages/LoginC/Login";
import RequireAuth from "./components/RequireAuth";
import CommunityPortalInfoView from './pages/CommunityPortal/CommunityPortaInfoView';
import EditCommunityPortalInfo from './pages/CommunityPortal/EditCommunityPortalInfo';
import useAuth from './hooks/useAuth';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  const { auth } = useAuth();
 
  return (
    <>

            <Router>

            {auth?.accessToken && <SideBar></SideBar>}

              <div className={auth?.accessToken ? "app-content with-sidebar" : "app-content"}>
                <Routes>
                  <Route path="/" element={<><RequireAuth  /><Dashboard /></>} />
                  <Route path="/login" element={<Login />} />

                  {/* Slider */}
                  <Route path="/sliders/add" element={<><RequireAuth  /><AddSlider/></>}  />

                  {/* </Route> */}
                  <Route path="/sliders/view" element={<><RequireAuth  /><SliderView /></>} />
                  <Route path="/sliders/edit/:id" element={<><RequireAuth  /><EditSlider /></>} />

                  {/* Contact */}
                  <Route path="/contacts/add" element={<><RequireAuth /><AddContact /></>} />
                  <Route path="/contacts/view" element={<><RequireAuth /><ContactView /></>} />
                  <Route path="/contacts/edit/:id" element={<><RequireAuth /><EditContact /></>} />

                  {/* Testimonial */}
                  <Route path="/testimonials/add" element={<><RequireAuth /><AddTestimonial /></>} />
                  <Route path="/testimonials/view" element={<><RequireAuth /><TestimonialView /></>} />
                  <Route path="/testimonials/edit/:id" element={<><RequireAuth /><EditTestimonial /></>} />

                  {/* Product */}
                  <Route path="/our-experience/add" element={<><RequireAuth /><AddProduct /></>} />
                  <Route path="/our-experience/view" element={<><RequireAuth /><ProductView /></>} />
                  <Route path="/our-experience/edit/:id" element={<><RequireAuth /><EditProduct /></>} />

                  {/* About */}
                  {/* <Route path="/about/add" element={<><RequireAuth /><AddAbout /></>} /> */}
                  <Route path="/about/view" element={<><RequireAuth /><AboutView /></>} />
                  <Route path="/about/edit/:id" element={<><RequireAuth /><EditAbout /></>} />

                  {/* Footer */}
                  {/* <Route path="/footer/add" element={<><RequireAuth /><AddFooter /></>} /> */}
                  <Route path="/footer/view" element={<><RequireAuth /><FooterView /></>} />
                  <Route path="/footer/edit/:id" element={<><RequireAuth /><EditFooter /></>} />

                  {/* Service */}
                  {/* <Route path="/services/add" element={<><RequireAuth /><AddService /></>} /> */}
                  <Route path="/services/view" element={<><RequireAuth /><ServiceView /></>} />
                  <Route path="/services/edit/:id" element={<><RequireAuth /><EditService /></>} />

                  {/* Home Page Service */}
                  {/* <Route path="/homepage-services/add" element={<><RequireAuth /><AddHomePageService /></>} /> */}
                  <Route path="/homepage-services/view" element={<><RequireAuth /><HomePageServiceView /></>} />
                  <Route path="/homepage-services/edit/:id" element={<><RequireAuth /><EditHomePageService /></>} />

                  {/* Community Feature */}
                  <Route path="/community/feature/add" element={<><RequireAuth /><AddCommunityFeature /></>} />
                  <Route path="/community/feature/view" element={<><RequireAuth /><CommunityFeatureView /></>} />
                  <Route path="/community/feature/edit/:id" element={<><RequireAuth /><EditCommunityFeature /></>} />

                  
                  {/* Investment */}
                  {/* <Route path="/investment/add" element={<><RequireAuth /><AddInvestment /></>} /> */}
                  <Route path="/investment/view" element={<><RequireAuth /><InvestmentView /></>} />
                  <Route path="/investment/edit/:id" element={<><RequireAuth /><EditInvestment /></>} />


                  {/* Investment Disburse */}
                  <Route path="/investment/additional-disburse/add" element={<><RequireAuth /><AddInvestmentDisburse /></>} />
                  <Route path="/investment/additional-disburse/view" element={<><RequireAuth /><InvestmentDisburseView /></>} />
                  <Route path="/investment/additional-disburse/edit/:id" element={<><RequireAuth /><EditInvestmentDisburse /></>} />


                  {/* Community Portal */}
                  {/* <Route path="/community/web-portal/add" element={<><RequireAuth /><AddCommunityPortalInfo /></>} /> */}
                  <Route path="/community/web-portal/view" element={<><RequireAuth /><CommunityPortalInfoView /></>} />
                  <Route path="/community/web-portal/edit/:id" element={<><RequireAuth /><EditCommunityPortalInfo /></>} />

                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </div>
            
              <ToastContainer />
            </Router>

    </>
    
    
  );
}

export default App;
